module.exports = __webpack_public_path__ + "static/media/bt_top_locomo_normal.7a241722.png";